import { useState, useEffect } from 'react';
import { ADDRESSES } from '../config';

export function useContractAddresses() {
  const [contractAddresses, setContractAddresses] = useState({
    trinityMaster: ADDRESSES.TRINITY_MASTER,
    fedToken: ADDRESSES.FED,
    trinityToken: ADDRESSES.TRINITY_TOKEN,
    couponToken: ADDRESSES.COUPON_TOKEN,
    tBill: ADDRESSES.TBILL,
    pDai: ADDRESSES.PDAI,
    trinityBond: ADDRESSES.TRINITY_BOND,
    trinityBondFactory: ADDRESSES.TRINITY_BOND_FACTORY
  });

  // Load saved addresses on mount
  useEffect(() => {
    const savedAddresses = localStorage.getItem('trinity_contract_addresses');
    if (savedAddresses) {
      const addresses = JSON.parse(savedAddresses);
      setContractAddresses(addresses);
      // Update the ADDRESSES object
      Object.assign(ADDRESSES, {
        TRINITY_MASTER: addresses.trinityMaster,
        FED: addresses.fedToken,
        TRINITY_TOKEN: addresses.trinityToken,
        COUPON_TOKEN: addresses.couponToken,
        TBILL: addresses.tBill,
        PDAI: addresses.pDai,
        TRINITY_BOND: addresses.trinityBond,
        TRINITY_BOND_FACTORY: addresses.trinityBondFactory
      });
    }
  }, []);

  // Save addresses to localStorage
  const saveAddresses = () => {
    localStorage.setItem('trinity_contract_addresses', JSON.stringify(contractAddresses));
    // Update the ADDRESSES object
    Object.assign(ADDRESSES, {
      TRINITY_MASTER: contractAddresses.trinityMaster,
      FED: contractAddresses.fedToken,
      TRINITY_TOKEN: contractAddresses.trinityToken,
      COUPON_TOKEN: contractAddresses.couponToken,
      TBILL: contractAddresses.tBill,
      PDAI: contractAddresses.pDai,
      TRINITY_BOND: contractAddresses.trinityBond,
      TRINITY_BOND_FACTORY: contractAddresses.trinityBondFactory
    });
    // Force a page reload to apply new addresses
    window.location.reload();
  };

  return {
    contractAddresses,
    setContractAddresses,
    saveAddresses
  };
} 